(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["meller-product-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('meller-product-info')) {
    customElements.define('meller-product-info', class extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          const button = event.target.closest('.meller-info__benefit');
          if (!button || !this.contains(button)) return;
          const open = button.getAttribute('aria-expanded') !== 'true';
          this.querySelectorAll('.meller-info__benefit').forEach((item) => {
            const active = item === button && open;
            item.setAttribute('aria-expanded', String(active));
            const panel = this.querySelector('[id="' + item.getAttribute('aria-controls') + '"]');
            if (panel) panel.hidden = !active;
          });
        };
        this.addEventListener('click', this.onClick);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
